import { useCallback, useEffect, useRef, useState } from "react";

export const useMarketplaceResource = (load, dependencies = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const requestRef = useRef(null);
  const loadRef = useRef(load);
  loadRef.current = load;

  const refresh = useCallback(async () => {
    // Inline loaders are common on marketplace pages. Reuse the current
    // request instead of starting a new request on every render.
    if (requestRef.current) return requestRef.current;
    setLoading(true);
    setError(null);
    const request = (async () => {
      try {
        const result = await loadRef.current();
        setData(result);
        return result;
      } catch (err) {
        setError(err);
        return null;
      } finally {
        setLoading(false);
        requestRef.current = null;
      }
    })();
    requestRef.current = request;
    return request;
  }, []); // loader is read from a ref; inline loaders cannot retrigger the effect

  useEffect(() => {
    refresh();
    // Dependencies are values supplied by the page (usually listing ID/filter key).
  }, dependencies);

  return {
    data,
    loading,
    error,
    refresh,
  };
};

export const collection = (data) =>
  data?.items ||
  data?.results ||
  data?.negotiations ||
  data?.listings ||
  data?.approvals ||
  data?.purchaseOrders ||
  data?.data ||
  (Array.isArray(data) ? data : []);

export const pageInfo = (data) => ({
  total: data?.total ?? data?.pagination?.total,
  totalPages: data?.totalPages ?? data?.pagination?.totalPages,
});
